import { kebabToCamel } from "@/common/helpers/strings";
import { attrToProp } from "../helpers";
// Plugin
export default {
    install(app, options) {
        const { el, reactiveAttrs, rootProps } = options;
        // Only install plugin if the reactiveAttrs option is set to true AND rootProps is not undefined.
        if (!reactiveAttrs || !rootProps)
            return;
        // Watch the element's attributes in order to keep the Vue app's props synced with them.
        const attributesObserver = new MutationObserver((r) => {
            r.forEach(({ attributeName, target }) => {
                if (!attributeName || attributeName === "data-v-app" || !attributeName.startsWith("data-"))
                    return;
                const rawValue = target?.attributes.getNamedItem(attributeName)?.value;
                const name = kebabToCamel(attributeName.replace(/^data-/, ""));
                const [key, value] = Object.entries(attrToProp(name, rawValue))[0];
                rootProps[key] = value;
            });
        });
        attributesObserver.observe(el, { attributes: true });
        // Use mixins to disconnect the element's attributes observer when the Vue app is unmounted.
        app.mixin({
            beforeUnmount() {
                // This ensures that the observer is only disconnected when the root component is unmounted.
                if (this.$root !== this)
                    return;
                attributesObserver.disconnect();
            }
        });
    }
};
